// removed by extract-text-webpack-plugin
module.exports = {"cell":"PhysiciansListPage__cell___1AbMM","isNotActive":"PhysiciansListPage__isNotActive___15oEt","sortableColumn":"PhysiciansListPage__sortableColumn___1yTXp"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/pages/PhysiciansListPage.css
// module id = 1220
// module chunks = 0